import React, { useMemo } from 'react';
import { Row, Col } from 'antd';
import PropTypes from 'prop-types';

import NuxPopover from '../../nux/NuxPopover';

import {
  FORMS_ADD_NUX_STEP_1_SWITCH_TEXT,
} from '../../nux/nux.constants';
import OnTraccrSwitch from '../../common/inputs/OnTraccrSwitch';
import OnTraccrCheckbox from '../../common/inputs/OnTraccrCheckbox';

export default function FormDefaultData({
  title,
  disabled,
  onEditableChange, // if form field is Collect Signature or Geolocation
  onCheckChange: onPropCheckChange,
  checkName = '',
  values:{
    collect: selected,
    editable
  } = {},
  isDisplay = false,
  showNux = false,
}){
  const getSubView =  () => {
    if (checkName === 'employeeSignature') {
        return (editable ? 'Load Saved Signature' : 'Disable Saved Signature');
    }
    if (checkName === 'reassignAll') {
      return (editable ? 'Reassign All' : 'Reassign Own');
    }
    return (editable ? 'Editable' : 'Not editable')
  }

  const editableView = useMemo(() => {
    const subView = getSubView()
    if(!showNux) return subView;
    return (
      <NuxPopover
        placement='right'
        text={FORMS_ADD_NUX_STEP_1_SWITCH_TEXT}
        visible
      >
        {subView}
      </NuxPopover>
    )
  },[editable,showNux]);

  // Only show selected or default (disabled) options in display mode
  if(isDisplay && !selected && !disabled) return null;

  return (
    <Row className="form-default-data-row" justify='space-between'>
      <Col>
        <Row gutter={10} >
          {!isDisplay && <Col>
            <OnTraccrCheckbox
              onChange={onPropCheckChange}
              disabled={disabled}
              value={selected || disabled}
              label={title}
            />
          </Col>}
          {!!isDisplay && (
            <Col>
              {title}
            </Col>
          )}
        </Row>
      </Col>

      <Col style={{ width: 250 }}>
      {selected && onEditableChange &&
        <Row gutter={10} justify='start'>
          {!isDisplay && <Col>
            <OnTraccrSwitch
              defaultChecked={editable}
              onChange={(checked) => {
                onEditableChange(checked);
              }}
              title={editableView}
            />
          </Col>}
          { !!isDisplay && (
            <Col>
              {editableView}
            </Col>
          )}
        </Row>
        }
      </Col>
    </Row>
  );
};

FormDefaultData.propTypes = {
  checkName: PropTypes.string,
};